import React from 'react';
import { Youtube, ArrowUpRight } from 'lucide-react';
import { YOUTUBE_SUBSCRIBE_URL, YOUTUBE_HANDLE } from '../../lib/socialLinks';

/**
 * Banner do canal AAAviation no YouTube.
 * Fica na home, logo abaixo do card "Mais Lidos da Semana" (coluna lateral),
 * com a mesma estrutura, raio e sombra daquele card, em vermelho (gradiente sutil).
 * Contraste (WCAG AA): branco sobre #C81E1E = 5,7:1; texto #B91C1C sobre o botão branco = 6,5:1.
 * - Celular e desktop (coluna lateral): conteúdo empilhado, botão de largura total.
 * - Tablet (md, coluna em largura total): texto à esquerda e botão à direita.
 */
export const YouTubeChannelBanner: React.FC = () => {
  return (
    <section
      aria-labelledby="youtube-channel-banner-title"
      className="bg-linear-to-br from-[#C81E1E] to-[#991B1B] dark:from-[#991B1B] dark:to-[#7F1D1D] rounded-2xl border border-[#B91C1C] dark:border-red-900 p-5 sm:p-6 shadow-xs text-white"
    >
      {/* Cabeçalho no mesmo padrão do card "Mais Lidos da Semana" */}
      <div className="flex items-center justify-between gap-3 pb-3 mb-4 border-b border-white/20">
        <div className="flex items-center gap-2.5">
          {/* Ícone de play do YouTube em destaque: corpo branco preenchido e triângulo vermelho */}
          <Youtube
            className="w-10 h-10 shrink-0 text-white drop-shadow-sm [&>path:first-child]:fill-white [&>path:last-child]:fill-[#B91C1C] [&>path:last-child]:stroke-[#B91C1C]"
            strokeWidth={1.5}
            aria-hidden="true"
          />
          <span className="text-sm font-bold uppercase font-['Outfit'] tracking-wider text-white">
            Canal no YouTube
          </span>
        </div>
        <span className="text-[10px] font-mono font-bold text-white bg-white/15 px-2 py-0.5 rounded-full">
          {YOUTUBE_HANDLE}
        </span>
      </div>

      <div className="flex flex-col md:flex-row md:items-center lg:flex-col lg:items-stretch gap-4 md:gap-6 lg:gap-4">
        <div className="flex-1 space-y-1.5">
          <h3
            id="youtube-channel-banner-title"
            className="text-base sm:text-lg font-bold leading-snug text-white font-['Outfit']"
          >
            Aviação explicada em vídeo
          </h3>
          <p className="text-xs sm:text-sm leading-relaxed text-red-50">
            Como o avião funciona, um conceito por vez, por quem vive manutenção e segurança de voo.
          </p>
        </div>

        <a
          href={YOUTUBE_SUBSCRIBE_URL}
          target="_blank"
          rel="noopener"
          aria-label="Inscreva-se no canal AAAviation no YouTube (abre em uma nova aba)"
          title="Canal AAAviation no YouTube: curiosidades de aviação, manutenção aeronáutica e segurança de voo em vídeo"
          className="w-full md:w-auto lg:w-full shrink-0 min-h-[44px] inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-xl bg-white text-[#B91C1C] hover:bg-red-50 hover:text-[#991B1B] hover:shadow-md hover:-translate-y-px active:translate-y-0 shadow-sm text-xs font-bold font-['Outfit'] transition-all focus:outline-hidden focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#991B1B]"
        >
          <span>Inscreva-se no canal</span>
          <ArrowUpRight className="w-3.5 h-3.5" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
};
